import { IMG } from "./i18n";

export const QUESTIONS = [
  {
    q: "Qual è la tua priorità di bellezza oggi?",
    a: [
      ["Una pelle più giovane e compatta", { proage: 3 }],
      ["Una pelle pulita, senza imperfezioni", { acne: 3 }],
      ["Una silhouette più definita", { body: 3, lipo: 2, meso: 2 }],
      ["Pelle liscia, senza pensieri", { laser: 3 }],
      ["Mani sempre curate", { hands: 3 }],
      ["Una pelle idratata e luminosa", { mesopor: 3, proage: 1 }],
    ],
  },
  {
    q: "Com'è la tua pelle a metà giornata?",
    a: [
      ["Lucida, soprattutto sulla zona T", { acne: 2 }],
      ["Secca, la sento tirare", { proage: 2, mesopor: 2 }],
      ["Sensibile, si arrossa facilmente", { proage: 1, acne: 1 }],
      ["Equilibrata, nessun problema", { hands: 1, mesopor: 1 }],
    ],
  },
  {
    q: "Cosa noti di più allo specchio?",
    a: [
      ["Linee sottili e un viso meno luminoso", { proage: 2 }],
      ["Brufoli o punti neri", { acne: 2 }],
      ["Gonfiore o ritenzione", { body: 2, meso: 1 }],
      ["Cuscinetti su pancia o fianchi", { lipo: 3, body: 1 }],
      ["Cellulite o pelle a buccia d'arancia", { meso: 3 }],
      ["La ricrescita dei peli", { laser: 2 }],
      ["Pelle spenta e disidratata", { mesopor: 3 }],
    ],
  },
  {
    q: "Quanto tempo dedichi alla bellezza ogni mattina?",
    a: [
      ["5 minuti, voglio praticità", { laser: 2, mesopor: 1 }],
      ["Circa 15 minuti", { proage: 1, hands: 1 }],
      ["Amo il mio rituale, senza fretta", { proage: 1, hands: 2 }],
    ],
  },
  {
    q: "Hai un'occasione speciale in arrivo?",
    a: [
      ["Sì, a breve", { hands: 3, proage: 1, mesopor: 2 }],
      ["No, cerco risultati duraturi", { proage: 1, body: 1, laser: 2, lipo: 1 }],
      ["Voglio solo coccolarmi", { body: 2, mesopor: 1 }],
    ],
  },
];

export const RESULTS = {
  mesopor: { product: "crema-viso-arancia-vitamina-c", title: "Mesoporazione estetica", service: "Mesoporazione estetica", img: "/images/mesoporazione-estetica.jpg", pos: "50% 40%",
    text: "La tua pelle ha sete di idratazione e luce. La mesoporazione, la \"mesoterapia senza aghi\", aiuta i principi attivi a penetrare più in profondità: viso più idratato, tonico e luminoso già dalla prima seduta, senza tempi di recupero.",
    tip: "A casa: bevi molta acqua e usa ogni mattina la crema all'arancia con vitamina C di Gioia Skincare." },
  proage: { product: "crema-viso-arancia-vitamina-c", title: "Trattamento viso pro-age", service: "Trattamento viso pro-age", img: IMG.realFace, pos: "50% 25%",
    text: "La tua pelle chiede compattezza e luminosità. Un percorso pro-age personalizzato lavora su tono, elasticità e linee sottili, con risultati che crescono seduta dopo seduta.",
    tip: "A casa: la crema all'arancia con vitamina C di Gioia Skincare per un incarnato più uniforme." },
  acne: { product: "crema-viso-calendula-pelle-sensibile", title: "Trattamento per l'acne", service: "Trattamenti per l'acne", img: IMG.faceCard, pos: "50% 50%",
    text: "Hai bisogno di riequilibrio, non di aggressività. Detersione profonda, pulizia accurata e attivi purificanti e lenitivi per ridurre imperfezioni e rossori.",
    tip: "A casa: detersione delicata mattina e sera, e niente fai da te aggressivo." },
  body: { title: "Trattamento corpo snellente", service: "Trattamento corpo snellente", img: IMG.realBody, pos: "50% 60%",
    text: "Il tuo corpo chiede leggerezza. Un percorso snellente che unisce tecnologie dedicate e manualità drenanti aiuta su ritenzione, tono e aspetto della pelle.",
    tip: "Per coccolarti di più: aggiungi un massaggio rilassante al percorso." },
  meso: { title: "Mesoterapia estetica", service: "Mesoterapia estetica", img: IMG.realBack, pos: "50% 45%",
    text: "Vuoi una pelle più compatta e levigata. La mesoterapia estetica lavora in modo mirato su ritenzione e inestetismi della cellulite, per gambe e glutei dall'aspetto più tonico seduta dopo seduta.",
    tip: "Bevi molta acqua e abbinala a un massaggio drenante per potenziare i risultati." },
  lipo: { title: "Lipolaser", service: "Lipolaser", img: IMG.realBody, pos: "50% 60%",
    text: "Cerchi una silhouette più definita dove serve. Il lipolaser agisce sulle adiposità localizzate di pancia, fianchi e cosce, per un percorso di rimodellamento non invasivo e senza tempi di recupero.",
    tip: "Per risultati migliori: abbinalo a un trattamento corpo snellente e a uno stile di vita attivo." },
  laser: { product: "crema-viso-calendula-pelle-sensibile", title: "Depilazione laser diodo", service: "Depilazione laser", img: IMG.realLaser, pos: "50% 45%",
    text: "Cerchi una soluzione duratura. Il laser diodo agisce in modo progressivo: seduta dopo seduta i peli diventano più sottili e radi, e la ricrescita si riduce nel tempo.",
    tip: "L'autunno e l'inverno sono il momento migliore per iniziare il ciclo." },
  hands: { product: "crema-mani", title: "Manicure e cura delle mani", service: "Manicure", img: IMG.nails, pos: "60% 75%",
    text: "Le mani raccontano chi sei. Una manicure professionale, o unghie in acrilico per chi ama osare, per un look curato in ogni occasione.",
    tip: "Trend di stagione: bordeaux e ciliegia scura." },
};

export const score = (answers) => {
  const s = {};
  answers.forEach((w) => Object.entries(w).forEach(([k, v]) => { s[k] = (s[k] ?? 0) + v; }));
  return Object.entries(s).sort((a, b) => b[1] - a[1]).map(([k]) => k);
};
